/* Close an open sidebar-drawer (cart, search, mobile nav) when the click lands
   outside it — Justin 2026-07-29.

   The theme's <sidebar-drawer> element (assets/section-header.js) only wires
   [data-js-close] and the ESC key, so the drawer stayed open on an outside click.
   This lives in its own asset rather than patching section-header.js: that file is
   core theme JS that other sessions rewrite, and this would be silently lost.

   Notes on the implementation:
   - pointerdown, not click: the drawer's own close animation removes nodes, and a
     late click can land on whatever slid into place underneath.
   - The click that OPENS the drawer must be ignored, or the drawer would close
     immediately on the same gesture. Any [aria-controls="<drawer id>"] toggle is
     excluded, and so is a fresh open (guarded by a short grace window).
   - hide() is the element's own method, so body classes, inert elements and
     aria-expanded all unwind exactly as the X button does. Falls back to clicking
     [data-js-close] if the custom element hasn't upgraded yet.
   - CAPTURE phase, not bubble: the theme and its apps attach their own pointerdown
     handlers, and anything calling stopPropagation() on the way up would have kept
     this from ever running. Capture also means the drawer closes before whatever
     was clicked reacts to it.
   - section-header.js has its own .site-overlay click handler, but it lives in the
     <site-header> connectedCallback, and this store's header is sections/dtf-header.liquid
     (no <site-header> element), so that whole init never runs. Nothing else closed the
     drawer on an outside click. */
(function () {
  'use strict';
  if (window.__drawerOutsideClose) return;
  window.__drawerOutsideClose = true;

  var GRACE_MS = 250;
  var openedAt = 0;

  /* stamp the moment a drawer opens, so the opening gesture can't also close it */
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('[aria-controls]')) openedAt = Date.now();
  }, true);

  document.addEventListener('pointerdown', function (e) {
    var drawer = document.querySelector('sidebar-drawer.sidebar--opened');
    if (!drawer) return;
    if (Date.now() - openedAt < GRACE_MS) return;

    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('sidebar-drawer')) return;                      /* inside a drawer */
    if (t.closest('[aria-controls="' + drawer.id + '"]')) return; /* its own toggle */
    if (t.closest('.modal, [role="dialog"], .customTabelPopup__overlay')) return;

    if (typeof drawer.hide === 'function') {
      drawer.hide();
    } else {
      var x = drawer.querySelector('[data-js-close]');
      if (x) x.click();
    }
  }, true);
})();
